import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Anesthesia = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="anesthesia icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.8088 8.94253C36.2807 8.94253 35.8528 9.37063 35.8528 9.89856V19.3396C33.2044 18.0538 31.2214 15.5294 30.7543 12.4908C30.6833 12.0286 30.6474 11.5556 30.6474 11.0848C30.6474 10.6986 30.6717 10.3088 30.7198 9.92668V9.92677C31.2545 5.6769 34.6765 2.39928 38.8641 1.96171V20.2067C38.4914 20.167 38.1246 20.1039 37.7649 20.0198V9.89856C37.7649 9.37063 37.3369 8.94253 36.8088 8.94253ZM28.7511 11.68H16.4756V10.7633H28.7399V10.7634L28.7403 10.7627C28.7372 10.8702 28.7351 10.9777 28.7351 11.0848C28.7351 11.2845 28.7425 11.4842 28.7532 11.6839L28.7511 11.68ZM29.4652 23.2845V46.0815H9.11224V23.2845C9.11224 19.7515 11.9864 16.8771 15.5196 16.8771H23.0581C26.5909 16.8771 29.4652 19.7514 29.4652 23.2845ZM16.4756 14.965H22.102V13.5921H16.4756V14.965ZM16.4756 8.85126H22.102V7.47838H16.4756V8.85126ZM39.8201 0C34.5307 0 30.0044 3.74968 28.9611 8.85125H24.0139V6.52234C24.0139 5.99442 23.586 5.56632 23.0579 5.56632H15.5195C14.9915 5.56632 14.5634 5.99442 14.5634 6.52234V15.0203C10.4248 15.496 7.2 19.0204 7.2 23.2844V47.0375C7.2 47.5655 7.6281 47.9936 8.15612 47.9936H30.4211C30.9491 47.9936 31.3772 47.5655 31.3772 47.0375V23.2845C31.3772 19.0205 28.1525 15.4961 24.0139 15.0204V13.5921H29.0228C29.5497 15.8638 30.7881 17.9278 32.5691 19.4695C34.5809 21.2107 37.1561 22.1697 39.8201 22.1697C40.3481 22.1697 40.776 21.7416 40.776 21.2137V0.956028C40.776 0.428099 40.3481 0 39.8201 0Z"
    />
  </svg>
)
